import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  hasTrackingConsent,
  setTrackingConsent,
  initTracking,
} from '../../utils/yandexMetrika';
import './CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (hasTrackingConsent()) {
      // Согласие уже было получено ранее — инициализируем трекинг и не показываем баннер
      initTracking();
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setTrackingConsent(true);
    initTracking();
    setVisible(false);
  };

  const handleDecline = () => {
    setTrackingConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite">
      <div className="cookie-consent__inner">
        <p className="cookie-consent__text">
          Мы используем cookies и сервисы аналитики (Яндекс.Метрика, в т.ч. Вебвизор, и UIS — коллтрекинг)
          для улучшения работы сайта и анализа посещаемости. Продолжая использовать сайт, вы соглашаетесь
          с обработкой данных в соответствии с{' '}
          <Link to="/privacy" className="cookie-consent__link">политикой конфиденциальности</Link>.
        </p>
        <div className="cookie-consent__buttons">
          <button type="button" className="cookie-consent__btn cookie-consent__btn--decline" onClick={handleDecline}>
            Отклонить
          </button>
          <button type="button" className="cookie-consent__btn cookie-consent__btn--accept" onClick={handleAccept}>
            Принять
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
